/**
 * Formats a date from yyyy-mm-dd to dd/mm/yyyy
 * @param {string} dateStr - The date string in yyyy-mm-dd format
 * @returns {string} - The formatted date string in dd/mm/yyyy format
 */
export const formatDate = (dateStr: string | undefined): string => {
    if (!dateStr) {
        return 'Invalid date';
    }

    const parts = dateStr.split('-');
    if (parts.length !== 3) {
        return 'Invalid date format';
    }
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
};

/**
 * Gets the current date as dd/mm/yyyy
 **/

export const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
};
